import React from "react";
import PostTable from "../PostTable";

const PostTableWrapper = ({
  postData,
  sortedPosts,
  sortOption,
  handleSortChange,
  getButtonClass,
}) => (
  postData && (
    <div className="mt-8 p-4 container mx-auto">
      <PostTable
        posts={sortedPosts()}
        sortOption={sortOption}
        handleSortChange={handleSortChange}
        getButtonClass={getButtonClass}
      />
    </div>
  )
);

export default PostTableWrapper;
